import Queue from '@utils/queue'
import {store} from '@/store'
import { SetupGuideEnum, OrdersEnum, BaseRouteEnum } from '@/enums/modules/routes'
import Strings from '@utils/strings'

/* #region STORE CONSTANTS */
const USER_GETTER = 'user/getUser'
const SPLASH_SCREEN_GETTER = 'showSplashScreen'
const SET_FUN_FACTS_ACTION = 'setSplashScreenMessage'
const TOGGLE_SPLASH_SCREEN_ACTION = 'toggleSplashScreen'
const splashScreenBlackList = [
  SetupGuideEnum.SignUp, SetupGuideEnum.SignUpPreLaunch, SetupGuideEnum.SignUpWithToken, SetupGuideEnum.Login,
  SetupGuideEnum.ForgotPassword, SetupGuideEnum.ForgotYourPassword, SetupGuideEnum.CheckYourEmail,
  BaseRouteEnum.Dashboard]
/* #endregion */

const queue = new Queue()
const preFetchComponents = {
  users: async (toUrl) => {
    return splashScreenBlackList.indexOf(toUrl) === -1 && store.getters[USER_GETTER].isDefault()
  },
  [OrdersEnum.OrdersWithView]: () => {
    return store.state['orders'] === undefined
  }
}

const componentFunFacts = {
  users: () => store.dispatch(SET_FUN_FACTS_ACTION, Strings.splashScreenMessages.user),
  [OrdersEnum.OrdersWithView]: () => store.dispatch(SET_FUN_FACTS_ACTION, Strings.splashScreenMessages.orders)
}
const add = (key) => {
  queue.enqueue(key)
  store.dispatch(TOGGLE_SPLASH_SCREEN_ACTION, true)
  if (componentFunFacts[key]) {
    componentFunFacts[key]()
  }
}
const remove = () => {
  queue.dequeue()
  // no items in queue
  if (queue.peek() === null) {
    store.dispatch(TOGGLE_SPLASH_SCREEN_ACTION, false)
  }
}

const isActive = () => store.getters[SPLASH_SCREEN_GETTER]
export default {
  add,
  remove,
  preFetchComponents,
  isActive
}
